import {AxiosInstance} from "axios";

export default class UiBetaOptInApi {
	constructor(public readonly axiosInstance: AxiosInstance) {}

	// Deliberately does not swallow errors into a fallback value -- `false` is a meaningful,
	// stored "user declined" answer, and callers (e.g. BetaOptInGuard) must be able to tell
	// that apart from "the request failed" to avoid treating a network blip as a decline.
	fetchOptIn(): Promise<boolean | null> {
		const url = "/api/users/me/ui-beta-opt-in";
		return this.axiosInstance.get(url)
			.then(resp => resp.data.optIn);
	}

	putOptIn(optIn: boolean): Promise<void> {
		const url = "/api/users/me/ui-beta-opt-in";
		return this.axiosInstance.put(url, {optIn});
	}
}
